<script lang="ts">
  import FAQ from '$lib/flexible/FAQ.svelte'
  import { page } from '$app/state';
  import { t } from 'svelte-i18n-lingui';
  import type { FullProduct } from "$lib/js/elasticsearch/types";
  import type { Settings } from "$lib/js/strapi/types";
  import '$lib/css/components/u-text.scss'

  interface Props {
    product: FullProduct;
    children?: import('svelte').Snippet;
  }

  let { product, children }: Props = $props();

  let settings: Settings = page.data.settings
  let fixed_tab = { title: $t`Description`, content: product.description }
  let tabs = [
    {
      icon: 'tree',
      question: $t`Sustainability and environment`,
      answer: settings.sustainability
    },
    {
      icon: 'shipping',
      question: $t`Shipping & Returns`,
      answer: settings.shipping
    }
  ]
</script>


<div class="product-tabs">
  <div class="product-tabs__inner">
    <div class="product-tabs__tab">
      <h2 class="product-tabs__title lead-1"><span class="icon icon-desc"></span>{fixed_tab.title}</h2>
      <div class="product-tabs__desc u-text">
        {@html fixed_tab.content}
      </div>
      {#if product.type_id === "simple" && product.ean13}
        <p class="ean">{'EAN:'} <i>{product.ean13}</i></p>
      {/if}
    </div>

    {#each tabs as tab, index}
      <FAQ faq={tab} color="black" />
    {/each}
    <!-- <FAQs faqs={tabs} color="black" current="{-1}"/> -->

    <div class="gallery">
      {@render children?.()}
    </div>
  </div>
</div>


<style lang="scss">
  .gallery {
    margin-bottom: 20px;
  }

  .ean {
    margin-top: 25px;
  }

  .product-tabs {
    margin-top: 50px;

    &__title {
      span {
        font-size: 18px;
        margin-right: 12px;
      }
    }

    &__tab {
      margin-bottom: 30px;
      border: 1px solid #c5c5c5;
      padding: 15px;
      border-radius: 5px;

      @media (min-width: 769px) {
        padding: 20px 25px;
      }
    }
  }
</style>
